import { request, avatarUpload } from './request';

export const getAllDoctors = () => request('doctors');

export const getAllActiveDoctors = (page = 1, isActive = true, limit = 50) =>
  request(`doctors?isActive=${isActive}&page=${page}&limit=${limit}`);

export const getDoctorById = (id) => request(`doctors/${id}`);
export const createDoctor = (body) =>
  request(
    `doctors`,
    {
      method: 'POST',
      body,
    },
    'Invitation link was sent to the user!',
  );
export const updateDoctor = (id, body) =>
  request(
    `doctors/${id}`,
    {
      method: 'PATCH',
      body,
    },
    'Doctor updated successfully!',
  );
export const uploadAvatar = (id, file) => avatarUpload(`doctors/${id}`, file);
